/* eslint-disable no-unused-vars */
/**
 * Take a flattened object and make nested object from it
 *
 * @param {String} flattened
 * @param {String} delimiter
 *
 * @return {Object}
 */
export default function unflatten (flattened, delimiter = '.') {
    let object = {};

    for (let key in flattened) {
        let path = key.split(delimiter);

        setIn(path, object, flattened[key]);
    }

    return object;
}

function setIn (path, object, value) {
    let [key, ...keys] = path;

    if (keys.length === 0) {
        object[key] = value;
    } else {
        let nextKey = keys[0];

        object[key] = object[key] || isNaN(nextKey) ? object[key] ? object[key] : {} : [];
        setIn(keys, object[key], value);
    }

    return object;
}
